<template>
  <div class="container my-4">
    <div class="component-header mb-4">
      <h1>O projekcie</h1>
      <div class="ml-4 add-edit-actions">
        <button type="submit" form="about-project-details" class="action">
          <i class="fa fa-floppy-o" aria-hidden="true"></i>
        </button>
      </div>
      <div
        class="saved-text"
        v-bind:class="[showMessage ? 'visible' : 'hidden', success ? 'text-success' : 'text-danger']"
      >
        {{ messageText }}
      </div>
    </div>
    <form id="about-project-details" @submit.prevent="save">
      <div class="form-row">
        <div class="form-group col-md-6">
          <label for="aboutProjectContentPL">Opis w języku polskim</label>
          <div>
            <vue-editor
              id="aboutProjectContentPL"
              v-model="aboutProject.contentPL"
              :editor-toolbar="$settings.editorToolbar"
            />
          </div>
        </div>
        <div class="form-group col-md-6">
          <label for="aboutProjectContentDE">Opis w języku niemieckim</label>
          <div>
            <vue-editor
              v-model="aboutProject.contentDE"
              id="aboutProjectContentDE"
              :editor-toolbar="$settings.editorToolbar"
            />
          </div>
        </div>
      </div>
      <div class="form-row justify-content-md-center">
        <div class="form-group">
          <div class="form-group col-md-6">
            <div v-if="aboutProject.imageData">
              <img
                id="card-image"
                :src="aboutProject.imageData"
                width="300"
                height="300"
              />
              <button
                type="button"
                style="font-size: 20; margin-top: 20px;  margin-left: 100px;"
                class="btn btn-dark"
                aria-label="Usuń"
                @click="removeImage()"
              >
                <span aria-hidden="true">Usuń</span>
              </button>
            </div>
            <picture-input
              v-if="!aboutProject.imageData"
              ref="pictureInput"
              @change="onChange"
              id="projectPicture"
              style="z-index: 1; width: 300px; height: 300px"
              margin="16"
              accept="image/jpeg,image/png"
            >
            </picture-input>
          </div>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import { VueEditor } from "vue2-editor";
import PictureInput from "vue-picture-input";
export default {
  components: {
    PictureInput,
    VueEditor
  },
  data() {
    return {
      aboutProject: {
      
      },
      content: "",
      messageText: "",
      showMessage: false,
      id: null,
      controlImages: [],
      success: false
    };
  },
  methods: {
    initialize: function () {
        this.$api.getAboutProject().then((data) => {
          this.aboutProject = data;
        });
    },
   
    save: function () {
        this.$api.updateAboutProject(this.aboutProject).then((data) => {
        if (data.ok) {
          this.displaySucess();
          this.aboutProject = data.data;
        } else {
          this.displayFailure();
        }
      });
    },
    removeImage() {
      this.aboutProject.imageData = null;
    },
    createBase64Image(fileObject) {
      const reader = new window.FileReader();
      let self = this;
      reader.onloadend = function (event) {
        try {
          let res = event.target.result;
          self.aboutProject.imageData = res;
        } catch (err) {
          alert("Error: " + err);
        }
      };
      reader.readAsDataURL(fileObject);
    },
    onChange() {
      console.log("Picture changed!");
      if (this.$refs.pictureInput.file) {
        this.createBase64Image(this.$refs.pictureInput.file);
      } else {
        console.log("Old browser. No support for Filereader API");
      }
    },
    displaySucess: function () {
      this.messageText = "Dane zostały pomyślnie zapisane";
      this.showMessage = true;
      this.success = true;
      setTimeout(() => (this.showMessage = false), 3000);
    },
    displayFailure: function () {
      this.messageText = "Wystąpił błąd w zapisie danych";
      this.showMessage = true;
      this.success = false;
      setTimeout(() => (this.showMessage = false), 3000);
    },
    displayNonUniqueValue: function () {
      this.messageText =
        "Nie można zapisać osoby. Osoba o tym samym imieniu i nazwisku istnieje.";
      this.showMessage = true;
      this.success = false;
    },
    goBack() {
      this.$router.push({ name: "People" });
    },
    goBackWithSave() {
      this.save();
      this.goBack();
    },
  },
  created() {
    this.initialize();
  },
  beforeRouteUpdate(to, from, next) {
    this.initialize();
    next();
  },
};
</script>

<style>
#aboutProjectContentDE,
#aboutProjectContentPL {
  height: 450px;
}
#my-strictly-unique-vue-upload-multiple-image {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}

h1,
h2 {
  font-weight: normal;
}

ul {
  list-style-type: none;
  padding: 0;
}

li {
  display: inline-block;
  margin: 0 10px;
}

a {
  color: #42b983;
}
</style>